import { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/hooks/useTheme";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import ChiSiamo from "@/components/ChiSiamo";
import Direttivo from "@/components/Direttivo";
import Stadio from "@/components/Stadio";
import Tesseramento from "@/components/Tesseramento";
import News from "@/components/News";
import Galleria from "@/components/Galleria";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";

function App() {
  const [selectedTier, setSelectedTier] = useState(null);

  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-background text-foreground">
        <Toaster position="top-center" richColors />
        <Navbar />
        <main>
          <Hero />
          <Stats />
          <ChiSiamo />
          <Direttivo />
          <Stadio />
          <Tesseramento onSelectTier={(t) => setSelectedTier({ ...t, _ts: Date.now() })} />
          <News />
          <Galleria />
          <Contatti selectedTier={selectedTier} />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
